import sanitize from 'sanitize-html'

const textSanitizeConfig: sanitize.IOptions = {
  allowedTags: [],
  allowedAttributes: {},
}

const messageSanitizeConfig: sanitize.IOptions = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'u', 's', 'strike', 'del', 'code', 'pre'],
  allowedAttributes: {
    a: ['href', 'rel', 'target', 'class', 'title'],
    b: ['data-contact-uri', 'contenteditable'],
  },
}

/** Like sanitizeMessage, but keeps line breaks from contenteditable (Ctrl/Shift+Enter). */
const outboundMessageSanitizeConfig: sanitize.IOptions = {
  ...messageSanitizeConfig,
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'u', 's', 'strike', 'del', 'code', 'pre', 'br'],
}

const unescapeToText = (text: string) => {
  return text.replace(/&amp;/g, '&').replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
}

export const sanitizeToText = (html: string): string => {
  return unescapeToText(sanitize(html, textSanitizeConfig))
}

export const sanitizeMessage = (messageText: string): string => {
  return sanitize(messageText, messageSanitizeConfig)
}

/** Strip inline colors/fonts from composer HTML before linkify/send. Keeps formatting, mentions and br. */
export function sanitizeOutboundMessage (messageText: string): string {
  return sanitize(messageText, outboundMessageSanitizeConfig)
}
